import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxDatePipe,
  OnyxIconComponent,
  OnyxMessageComponent,
  OnyxMessageType,
} from '@onyx/angular';

@Component({
  selector: 'app-fleet-modal-warning',
  imports: [
    OnyxIconComponent,
    OnyxDatePipe,
    TranslatePipe,
    OnyxMessageComponent,
  ],
  templateUrl: './fleet-modal-warning.component.html',
  styleUrl: './fleet-modal-warning.component.scss',
})
export class FleetModalWarningComponent {
  public readonly type = input.required<`${OnyxMessageType}`>();
  public readonly expiryDate = input<string>();
  public readonly label = input<string>();
  public readonly count = input<number>();
  public readonly redirect = output<void>();

  protected readonly I18N = 'fleet.fleetModal';

  protected readonly OnyxMessageType = OnyxMessageType;
}
